import React, { useState } from 'react';
import Navbar from '../../Components/CMS/Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import TopNav from '../../Components/CMS/TopNav/TopNav';
import SEO from '../../common/SEO/SEO';

const CMSLayout = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);

  const toggleMenu = () => {
    setIsMenuActive((prev) => !prev);
  };

  return (
    <div className="flex min-h-screen bg-[#f9fafb] antialiased">
      <SEO title="Admin Portal" noindex={true} />
      <Navbar isMenuActive={isMenuActive} toggleMenu={toggleMenu} />
      <div className="flex-1 flex flex-col min-w-0 min-h-screen overflow-x-hidden">
        <TopNav isMenuActive={isMenuActive} toggleMenu={toggleMenu} />
        <main className="flex-1 min-w-0 p-3 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default CMSLayout;